import Link from "next/link";

import { routes } from "src/shared/routes";
import { useRouterExt } from "src/components/reusable/hooks/useRouterExt";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const FAQS: TTeamConfig["LANGUAGES"]["FAQS"] = [
  {
    question:
      "How do I claim my tickets? When does the opt in open before each game?",
    answer:
      "You will receive text when the window to check-in opens. The check-in window starts 24 hours prior to the game. The check-in window closes 4 hours prior to game start and you will be unable to confirm attendance after that time.",
  },
  {
    question:
      "Do I get a ticket to each game on the schedule? Are there penalties if I do not check in?",
    answer:
      "Tickets are guaranteed for each game on the schedule. There are no penalties for not attending a game, however you do need to confirm your attendance in order to receive a ticket.",
  },
  {
    question: "Where are my tickets?",
    answer:
      "Your tickets will be sent over 3 hours prior to game start and you can find the tickets within your Seatgeek account.",
  },
  {
    question: "How are tickets sent to me?",
    answer:
      "3 hours prior to game start you will receive a text confirming that tickets have been delivered to your Seatgeek account.",
  },
  {
    question: "Where will my seats be located?",
    answer: "Seat locations will vary by game.",
  },
  {
    question: "Can these tickets be transferred to a friend?",
    answer:
      "Ravens Pass tickets, as well as guest tickets, are not transferable and not eligible for resale. Abusing these guidelines can result in your Ravens Pass being revoked.",
  },
  {
    question: "Can I link tickets with other pass holders? ",
    answer:
      "You can link your pass with other pass holders using groups. Navigate to My Group in the right navigation menu to generate your unique invitation link and share with friends. This allows you to create and join ticket groups. All fans within a ticket group will be assigned seats next to each other.",
  },
  {
    question: "Can I bring a friend to a game?",
    answer:
      "Guest tickets will be available for select games. If available, guest tickets are available for purchase when you check into games.",
  },
  {
    question: "Can I receive a refund if I cannot attend a game?",
    answer: "We do not issue any refunds for games you are not able to attend.",
  },
];

export const TERMS_AND_CONDITION = () => (
  <>
    By checking this box you agree to the{" "}
    <Link target="_blank" href="https://www.attend.tech/terms-of-use">
      Terms of Use
    </Link>{" "}
    and{" "}
    <Link target="_blank" href="https://www.attend.tech/privacy-policy">
      Privacy Policy
    </Link>
    .
  </>
);

export const REGISTRATION_TERMS_AND_CONDITION = () => (
  <>
    By checking this box you agree to receive notifications and offers from the
    Baltimore Ravens and to the{" "}
    <Link target="_blank" href="https://www.attend.tech/terms-of-use">
      Terms of Use
    </Link>{" "}
    and{" "}
    <Link target="_blank" href="https://www.attend.tech/privacy-policy">
      Privacy Policy
    </Link>
    .
  </>
);

export const PASS_PURCHASE_SUCCESS_MESSAGE: TTeamConfig["LANGUAGES"]["PASS_PURCHASE_SUCCESS_MESSAGE"] =
{
  TITLE: () => <>You&apos;re all set to experience the action!</>,
  DESCRIPTION: () => {
    const router = useRouterExt();
    return (
      <>
        Invite your friends! Create groups{" "}
        <b>
          <u>
            <span
              onClick={() => router.pushSchema(routes.my_group)}
              style={{ cursor: "pointer" }}
            >
              here
            </span>
          </u>
        </b>
        .
      </>
    );
  },
};
